import { render, staticRenderFns } from "./TissueLicense.vue?vue&type=template&id=3d6e7c2c"
import script from "./TissueLicense.vue?vue&type=script&lang=js"
export * from "./TissueLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports